export let Brands = /*#__PURE__*/function (Brands) {
  Brands["WIX"] = "wix";
  Brands["EDITOR_X"] = "editorx";
  Brands["DAYFUL"] = "dayful";
  return Brands;
}({});
export let CardBrands = /*#__PURE__*/function (CardBrands) {
  CardBrands["Amex"] = "amex";
  CardBrands["BankTransfer"] = "bankTransfer";
  CardBrands["Boleto"] = "boleto";
  CardBrands["CarteBlue"] = "carteBlue";
  CardBrands["CreditsPrepaidCard"] = "creditsPrepaidCard";
  CardBrands["Diners"] = "diners";
  CardBrands["Discover"] = "discover";
  CardBrands["Elo"] = "elo";
  CardBrands["Jcb"] = "jcb";
  CardBrands["Maestro"] = "maestro";
  CardBrands["Mastercard"] = "mastercard";
  CardBrands["MercadoPagoRecurring"] = "mercadoPagoRecurring";
  CardBrands["MpBanamex"] = "mpBanamex";
  CardBrands["MpBancomer"] = "mpBancomer";
  CardBrands["MpOxxo"] = "mpOxxo";
  CardBrands["Payu"] = "payu";
  CardBrands["MpSerfin"] = "mpSerfin";
  CardBrands["RegDotRu"] = "regDotRu";
  CardBrands["SepaDirectDebit"] = "sepaDirectDebit";
  CardBrands["Solo"] = "solo";
  CardBrands["Unionpay"] = "unionpay";
  CardBrands["Visa"] = "visa";
  CardBrands["Sofort"] = "sofort";
  return CardBrands;
}({});
export let Country = /*#__PURE__*/function (Country) {
  Country["CA"] = "CA";
  Country["USA"] = "US";
  Country["GB"] = "GB";
  Country["AU"] = "AU";
  Country["FR"] = "FR";
  Country["BR"] = "BR";
  Country["RU"] = "RU";
  Country["DE"] = "DE";
  Country["JA"] = "JP";
  Country["IN"] = "IN";
  Country["BE"] = "BE";
  Country["CH"] = "CH";
  Country["ES"] = "ES";
  Country["IE"] = "IE";
  Country["IL"] = "IL";
  Country["IT"] = "IT";
  Country["KZ"] = "KZ";
  Country["NL"] = "NL";
  Country["NO"] = "NO";
  Country["NZ"] = "NZ";
  Country["PL"] = "PL";
  Country["PT"] = "PT";
  Country["SE"] = "SE";
  Country["TR"] = "TR";
  Country["ZA"] = "ZA";
  Country["AT"] = "AT";
  Country["BY"] = "BY";
  Country["BG"] = "BG";
  Country["HR"] = "HR";
  Country["CY"] = "CY";
  Country["CZ"] = "CZ";
  Country["DK"] = "DK";
  Country["FI"] = "FI";
  Country["GR"] = "GR";
  Country["HU"] = "HU";
  Country["IS"] = "IS";
  Country["LV"] = "LV";
  Country["LT"] = "LT";
  Country["RO"] = "RO";
  Country["SA"] = "SA";
  Country["SK"] = "SK";
  Country["SI"] = "SI";
  Country["UA"] = "UA";
  Country["AE"] = "AE";
  Country["AQ"] = "AQ";
  Country["AS"] = "AS";
  Country["EH"] = "EH";
  Country["FM"] = "FM";
  Country["GU"] = "GU";
  Country["IM"] = "IM";
  Country["MH"] = "MH";
  Country["MP"] = "MP";
  Country["PR"] = "PR";
  Country["PW"] = "PW";
  Country["VI"] = "VI";
  Country["AX"] = "AX";
  Country["BV"] = "BV";
  Country["HM"] = "HM";
  Country["UM"] = "UM";
  Country["PH"] = "PH";
  Country["EE"] = "EE";
  Country["LU"] = "LU";
  Country["MT"] = "MT";
  return Country;
}({});
export let Language = /*#__PURE__*/function (Language) {
  Language["CS"] = "cs";
  Language["DA"] = "da";
  Language["DE"] = "de";
  Language["EN"] = "en";
  Language["ES"] = "es";
  Language["FI"] = "fi";
  Language["FR"] = "fr";
  Language["HI"] = "hi";
  Language["IT"] = "it";
  Language["JA"] = "ja";
  Language["KO"] = "ko";
  Language["NL"] = "nl";
  Language["NO"] = "no";
  Language["PL"] = "pl";
  Language["PT"] = "pt";
  Language["RU"] = "ru";
  Language["SV"] = "sv";
  Language["TH"] = "th";
  Language["TR"] = "tr";
  Language["UK"] = "uk";
  Language["ZH"] = "zh";
  Language["VI"] = "vi";
  Language["ID"] = "id";
  Language["IN"] = "in";
  Language["INVALID"] = "invalid";
  return Language;
}({});
export let ProductFamily = /*#__PURE__*/function (ProductFamily) {
  ProductFamily["Default"] = "Default";
  ProductFamily["Pro"] = "Pro";
  ProductFamily["VIP"] = "Vip";
  ProductFamily["Unlimited"] = "Unlimited";
  ProductFamily["Enterprise"] = "Enterprise";
  ProductFamily["Vertical"] = "Vertical";
  ProductFamily["Evolve"] = "Evolve";
  ProductFamily["Grow"] = "Grow";
  ProductFamily["Sell"] = "Sell";
  ProductFamily["Combo"] = "Combo";
  ProductFamily["ConnectDomain"] = "Connect_Domain";
  ProductFamily["Essential"] = "Essential";
  ProductFamily["Extra"] = "Extra";
  ProductFamily["Ultra"] = "Ultra";
  ProductFamily["Launch"] = "Launch";
  ProductFamily["Boost"] = "Boost";
  ProductFamily["Scale"] = "Scale";
  ProductFamily["Lite"] = "Lite";
  ProductFamily["Basic"] = "Basic";
  ProductFamily["Standard"] = "Standard";
  ProductFamily["Advanced"] = "Advanced";
  ProductFamily["Dayful"] = "Dayful";
  ProductFamily["Light"] = "Light";
  ProductFamily["Core"] = "Core";
  ProductFamily["Business"] = "Business";
  ProductFamily["Elite"] = "Elite";
  ProductFamily["Plus"] = "Plus";
  return ProductFamily;
}({});
export let ProductTypeIds = /*#__PURE__*/function (ProductTypeIds) {
  ProductTypeIds["PremiumPlans"] = "8b1b47e6-9f58-4e59-b147-cac894bec8da";
  ProductTypeIds["Dayful"] = "b5824dc4-dfe0-447b-8e00-f6ab5c326ef6";
  ProductTypeIds["GoogleVoice"] = "7da77b74-5984-4e3b-8994-20e111eb3c16";
  ProductTypeIds["SocialMediaMarketing"] = "4c3e3818-7d2b-4860-8522-f7d4e2840ca6";
  ProductTypeIds["Gemini"] = "a3587209-d793-4cc5-93cc-f58402906779";
  ProductTypeIds["BusinessEmail"] = "9570ef56-e556-4282-9471-71779ad3d9b6";
  ProductTypeIds["EmailMarketing"] = "7f6a333b-83db-468a-925a-af09aa5800f2";
  ProductTypeIds["AiChat"] = "7a1d0217-67c4-479e-b38f-fb7b0c6fc776";
  return ProductTypeIds;
}({});
export let MediaDevices = /*#__PURE__*/function (MediaDevices) {
  MediaDevices["Desktop"] = "desktop";
  MediaDevices["Tablet"] = "tablet";
  MediaDevices["Mobile"] = "mobile";
  return MediaDevices;
}({});
export const QUERIES = {
  [MediaDevices.Desktop]: '(min-width: 1024px)',
  [MediaDevices.Tablet]: '(max-width: 1023px) and (min-width: 768px)',
  [MediaDevices.Mobile]: '(max-width: 767px)'
};

// please don't change type - https://jira.wixpress.com/browse/PREM-13075
export let PaymentCycle = /*#__PURE__*/function (PaymentCycle) {
  PaymentCycle["MONTHLY"] = "MONTHLY";
  PaymentCycle["QUARTERLY"] = "QUARTERLY";
  PaymentCycle["YEARLY"] = "YEARLY";
  PaymentCycle["YEAR2"] = "YEAR2";
  PaymentCycle["YEAR3"] = "YEAR3";
  PaymentCycle["YEAR4"] = "YEAR4";
  PaymentCycle["YEAR5"] = "YEAR5";
  return PaymentCycle;
}({});
export const TAX_INCLUDED_COUNTRIES = [Country.DE, Country.IL, Country.FR, Country.AU];
//# sourceMappingURL=enums.js.map